<template>
  <NavBar />
  <SectionProducts />
  <SectionClients />
  <SectionData />
  <SectionCompany />
  <SectionAccountability />
  <SectionContact />
  <Footer />
</template>

<script scoped>
import NavBar from '@/components/Navbar.vue'
import SectionProducts        from '@/components/SectionProducts.vue'
import SectionClients         from '@/components/SectionClients.vue'
import SectionData            from '@/components/SectionData.vue'
import SectionCompany         from '@/components/SectionCompany.vue'
import SectionAccountability  from '@/components/SectionAccountability.vue'
import SectionContact         from '@/components/SectionContact.vue'

import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    SectionProducts,
    SectionClients,
    SectionData,
    SectionCompany,
    SectionAccountability,
    SectionContact,
    Footer,
  },
}
</script>